export default "__VITE_ASSET__BtaD_oV0__"